import { useMemo, useState } from 'react';
import { Participant } from '../../Meet/domain/types';
import { useMeetContext } from '../../Meet/providers/MeetContextProvider';
import { truncateText } from '../../../utils/truncateText';

export function useParticipantInfo(): {
	isProfessional: boolean;
	patientData: Participant | undefined;
	professionalData: Participant | undefined;
	participantData: Participant | undefined;
	subject: string;
	subjectShort: string;
	speciality: string | undefined;
	startDate: string | undefined;
	duration: number | undefined;
	participantInfoModal: boolean;
	isSubjectTooLong: boolean;
	toggleParticipantInfoModal: () => void;
	} {
	const { meet, isProfessional, professionalData, patientData, participantData } = useMeetContext();
	const [participantInfoModal, setParticipantInfoModal] = useState(false);

	const toggleParticipantInfoModal = () => {
		setParticipantInfoModal(!participantInfoModal);
	};

	const isSubjectTooLong = useMemo(() => {
		return !!(meet?.subject && meet.subject.length > 125);
	}, [meet]);

	const subjectShort = useMemo(() => {
		if (!meet?.subject) {
			return '';
		}
		return truncateText(meet.subject, 125);
	}, [meet]);

	const subject = useMemo(() => {
		return meet?.subject || '';
	}, [meet]);

	const speciality = useMemo(() => {
		if (!meet?.meta?.speciality?.nameEs) {
			return undefined;
		}
		return meet.meta.speciality.nameEs;
	}, [meet]);

	const startDate = useMemo(() => {
		return meet?.startDate;
	}, [meet]);

	const duration = useMemo(() => {
		return meet?.duration;
	}, [meet]);

	return {
		isProfessional,
		patientData,
		professionalData,
		participantData,
		subject,
		subjectShort,
		speciality,
		startDate,
		duration,
		participantInfoModal,
		isSubjectTooLong,
		toggleParticipantInfoModal
	};
}